import { API_HOST_COMMS, API_HOST_REFDATA, API_HOST_SVR } from "../config";
import { NewsService } from "./NewsService";
import { TagsService } from "./TagsService";
import { ResourceTagsService } from "./ResourceTagsService";
import newsTypes from "./json/newsType.json";
import { LocalLookupService } from "@ofqual/portal-core/core/dataAccess";

export const newsService = new NewsService(API_HOST_COMMS);
export const tagsService = new TagsService(API_HOST_REFDATA);
export const resourceTagsService = new ResourceTagsService(API_HOST_SVR);
export const newsTypeService = new LocalLookupService(newsTypes);
